import React, { FC, ChangeEvent } from 'react';

type Props = {
    fieldProps: any;
    displayText: string;
    id: string;
    disabled?: boolean;
    comparisonValue?: any
};

export const AncientInputCheckboxJsonArray: React.FC<Props> = ({
        displayText,
        fieldProps,
        id,
        disabled,
        comparisonValue
    }) => {
    // Parse the fieldProps.value JSON string into an array or initialize an empty array
    const currentValues = JSON.parse(fieldProps.value || '[]');

    // Event handler to toggle checkbox values and update fieldProps.value as a JSON string
    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value: selectedValue } = event.target;

        // Check if the selectedValue is already in the currentValues
        const updatedValues = currentValues.includes(selectedValue)
            ? currentValues.filter((value: string) => value !== selectedValue)
            : [...currentValues, selectedValue];

        // Convert updatedValues to a JSON string
        const updatedValuesJsonString = JSON.stringify(updatedValues);

        // Update the fieldProps.value with the JSON string
        fieldProps.onChange({
            target: {
                name: fieldProps.name,
                value: updatedValuesJsonString,
            },
        });
    };
    
    // Determine if checkbox should be checked based on comparisonValue or currentValues
    const isPreviousSelection = comparisonValue
        ? comparisonValue.includes(displayText)
        : currentValues.includes(displayText);


    return (
        <div className="form-check form-check-custom form-check-solid form-check-sm mt-5 mb-5" key={id}>
            <input
                className="form-check-input"
                type="checkbox"
                checked={currentValues.includes(displayText)}
                value={displayText}
                id={id.toString()}
                onChange={handleCheckboxChange}
                disabled={disabled}
            />
            <label className="form-check-label" htmlFor={id.toString()}>
                {displayText} {isPreviousSelection && <i> - Current Selection</i>}
            </label>
        </div>
    );
};
